export enum OpportunityItemStatus {
  Pending = 'pending',
  Recruiting = 'recruiting',
  Ongoing = 'ongoing',
  Finalized = 'finalized',
  Deleted = 'deleted',
  Rejected = 'rejected',
  Canceled = 'canceled',
}

export enum OpportunityItemBasicStatus {
  Recruiting = 'recruiting',
  Ongoing = 'ongoing',
  Finalized = 'finalized',
  Canceled = 'canceled',
}

export enum OpportunityItemDefaultStatus {
  Pending = 'pending',
  Recruiting = 'recruiting',
  Ongoing = 'ongoing',
  Finalized = 'finalized',
}

export enum OpportunityItemBasicDefaultStatus {
  Recruiting = 'recruiting',
  Ongoing = 'ongoing',
  Finalized = 'finalized',
}

export enum OpportunityItemOtherStatus {
  Draft = 'draft',
}
